class FmOrderCountModel {
    constructor({ pickup_count = null, return_count = null, rto_count = null } = {}) {
        this.pickupCount = pickup_count;
        this.returnCount = return_count;
        this.rtoCount = rto_count;
    }

    static fromJson(json) {
        return new FmOrderCountModel({
            pickup_count: json.pickup_count,
            return_count: json.return_count,
            rto_count: json.rto_count,
        });
    }

    toJson() {
        return {
            pickup_count: this.pickupCount,
            return_count: this.returnCount,
            rto_count: this.rtoCount,
        };
    }
}
export {FmOrderCountModel};